import { fork, take, put, call } from "redux-saga/effects";
import { request, handleErrors } from "../../services/helpers";
import * as locationActions from "../actions/location";
import { REQUEST, SUCCESS, FAILURE } from "../actions/index";

function getLocationsApi() {
  return request.get("/buildings");
}

function* getLocations() {
  try {
    const res = yield call(getLocationsApi);
    yield put(locationActions.location.success(res.data));
  } catch (e) {
    const error = handleErrors(e);
    console.log(e, error);
    yield put(locationActions.location.failure(error));
  }
}

export function* locationWatcher() {
  while (true) {
    yield take(locationActions.LOCATION[REQUEST]);
    yield fork(getLocations);
  }
}
